export default "__VITE_ASSET__BtK$kYDF__"